<div class="dashboard-container">
    <!-- Header section -->
    <div class="flex items-center justify-between mb-4">
        <h2 class="text-xl font-semibold text-gray-800">Dashboard de Réconciliation</h2>
        <div class="flex gap-2">
            <input type="date" [(ngModel)]="selectedDate" (change)="loadReport()"
                class="px-3 py-1.5 border border-gray-200 rounded text-sm text-gray-700 focus:border-blue-500 outline-none">
            <button (click)="loadReport()" [disabled]="isLoading"
                class="flex items-center gap-2 px-3 py-1.5 bg-gray-100 text-gray-700 rounded hover:bg-gray-200 transition text-sm disabled:opacity-50">
                <i class="fa fa-sync-alt" [class.fa-spin]="isLoading"></i>
                <span>Actualiser</span>
            </button>
        </div>
    </div>

    <!-- Loading -->
    <div *ngIf="isLoading && !report" class="flex justify-center items-center py-20">
        <i class="fa fa-spinner fa-spin text-4xl text-gray-300"></i>
    </div>

    <div *ngIf="report">
        <!-- Summary Cards Premium -->
        <div class="stats-grid">
            <div class="stats-card">
                <div class="stats-icon icon-blue">
                    <i class="fa fa-money-bill-wave"></i>
                </div>
                <div class="stats-info">
                    <h4>{{ report.totalF8Amount | number:'1.2-2' }} MAD</h4>
                    <p>Encaissé (F8)</p>
                </div>
            </div>

            <div class="stats-card">
                <div class="stats-icon icon-purple">
                    <i class="fa fa-shopping-bag"></i>
                </div>
                <div class="stats-info">
                    <h4>{{ report.totalOrdersAmount | number:'1.2-2' }} MAD</h4>
                    <p>Vendu (Virtuel)</p>
                </div>
            </div>

            <div class="stats-card">
                <div class="stats-icon" [class.icon-green]="report.globalDiscrepancy === 0"
                    [class.icon-red]="report.globalDiscrepancy !== 0">
                    <i class="fa fa-chart-line"></i>
                </div>
                <div class="stats-info">
                    <h4 [class.text-success]="report.globalDiscrepancy === 0"
                        [class.text-danger]="report.globalDiscrepancy !== 0">
                        {{ report.globalDiscrepancy | number:'1.2-2' }}
                    </h4>
                    <p>Écart</p>
                </div>
            </div>

            <div class="stats-card">
                <div class="stats-icon icon-orange">
                    <i class="fa fa-clipboard-check"></i>
                </div>
                <div class="stats-info">
                    <h4>{{ report.summary === 'Aucune donnée pour cette date.' ? 'N/A' : (report.status ===
                        'FULLY_RECONCILED' ? 'OK' : 'Attention') }}</h4>
                    <p>Résultat</p>
                </div>
            </div>
        </div>

        <!-- CAMERA VERIFICATION SUMMARY -->
        <div
            *ngIf="report.verificationSummary && (report.verificationSummary.f8sToVerify?.length > 0 || report.verificationSummary.ordersToVerify?.length > 0)">
            <!-- SUCCESS STATE: No Discrepancy -->
            <div *ngIf="Math.abs(report.globalDiscrepancy || 0) <= 0.5"
                class="bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-300 rounded-xl p-5 mb-6 shadow-md">
                <div class="flex items-start gap-3">
                    <div class="text-3xl">✅</div>
                    <div class="flex-1">
                        <h3 class="text-lg font-bold text-green-800 mb-1">Rien à Signaler</h3>
                        <p class="text-sm text-green-700">Les montants sont parfaitement équilibrés (Écart: {{
                            report.globalDiscrepancy | number:'1.2-2' }} DH). Vous pouvez confirmer le scénario suggéré.
                        </p>
                    </div>
                </div>
            </div>

            <!-- WARNING STATE: Has Discrepancy -->
            <div *ngIf="Math.abs(report.globalDiscrepancy || 0) > 0.5"
                class="bg-gradient-to-r from-orange-50 to-yellow-50 border-2 border-orange-300 rounded-xl p-5 mb-6 shadow-md">
                <div class="flex items-start gap-3 mb-4">
                    <div class="text-3xl">📹</div>
                    <div class="flex-1">
                        <h3 class="text-lg font-bold text-orange-800 mb-1">Vérification Caméra Requise</h3>
                        <p class="text-sm text-orange-700">Consultez les vidéos de surveillance aux heures indiquées
                            pour confirmer les transactions.</p>
                    </div>
                    <!-- WORKBENCH BUTTON -->
                    <a [routerLink]="['/reconciliation-workbench']" [queryParams]="{ date: selectedDate }"
                        class="flex items-center gap-2 px-4 py-2 bg-orange-800 hover:bg-orange-900 text-white font-semibold rounded-lg text-sm transition-all shadow-md whitespace-nowrap">
                        <i class="fa fa-wrench"></i>
                        Poste de Travail Manuel
                    </a>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <!-- F8s to Verify -->
                    <div class="bg-white rounded-lg p-4 border border-orange-200">
                        <h4 class="font-semibold text-gray-800 mb-3 flex items-center gap-2">
                            <i class="fa fa-clock text-orange-600"></i>
                            F8s à vérifier ({{ report.verificationSummary.f8sToVerify?.length || 0 }})
                        </h4>
                        <div class="space-y-2 max-h-48 overflow-y-auto">
                            <div *ngFor="let f8 of report.verificationSummary.f8sToVerify"
                                class="flex items-center justify-between py-2 px-3 bg-gray-50 rounded hover:bg-gray-100 transition">
                                <div class="flex items-center gap-2">
                                    <span class="font-mono font-bold text-orange-700">{{ f8.timestamp }}</span>
                                    <span *ngIf="f8.amount < 0" class="avoir-tag">AVOIR</span>
                                </div>
                                <span class="font-semibold text-gray-800">{{ f8.amount | number:'1.2-2' }} DH</span>
                            </div>
                        </div>
                    </div>

                    <!-- Orders to Verify -->
                    <div class="bg-white rounded-lg p-4 border border-orange-200">
                        <h4 class="font-semibold text-gray-800 mb-3 flex items-center gap-2">
                            <i class="fa fa-shopping-cart text-orange-600"></i>
                            Commandes concernées ({{ report.verificationSummary.ordersToVerify?.length || 0 }})
                        </h4>
                        <div class="space-y-2 max-h-48 overflow-y-auto">
                            <div *ngFor="let order of report.verificationSummary.ordersToVerify"
                                class="flex items-center justify-between py-2 px-3 bg-gray-50 rounded hover:bg-gray-100 transition">
                                <div class="flex items-center gap-2">
                                    <span class="font-mono text-sm text-gray-600">#{{ order.id }}</span>
                                    <span *ngIf="order.amount === 0" class="avoir-tag">AVOIR</span>
                                </div>
                                <span class="font-semibold text-gray-800">{{ order.amount | number:'1.2-2' }} DH</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Analysis Grid -->
        <div class="two-columns">
            <!-- Suggestions Section -->
            <div class="orders-section">
                <div class="controls-bar">
                    <div class="flex items-center gap-2">
                        <i class="fa fa-lightbulb text-amber-500"></i>
                        <span class="font-semibold text-gray-700">Analyse et Suggestions</span>
                    </div>
                </div>
                <div class="cards-list">
                    <!-- Empty State -->
                    <div *ngIf="report.suggestions.length === 0" class="text-center py-10 text-gray-400">
                        <i class="fa fa-check-circle text-green-500 text-4xl mb-2 block"></i>
                        <p class="font-medium text-gray-600">Tout est en ordre !</p>
                        <p class="text-sm">Aucune suggestion ou problème détecté.</p>
                    </div>

                    <!-- Suggestions List -->
                    <div *ngFor="let sug of report.suggestions" class="suggestion-card"
                        [class.exact]="sug.matchStatus === 'EXACT'" [class.partial]="sug.matchStatus === 'PARTIAL'"
                        [class.orphan]="sug.matchStatus === 'ORPHAN_F8'"
                        [class.unmatched]="sug.matchStatus !== 'EXACT' && sug.matchStatus !== 'PARTIAL' && sug.matchStatus !== 'ORPHAN_F8'">

                        <div class="flex items-center justify-between mb-2">
                            <div class="flex items-center gap-2">
                                <span class="status-badge" [ngClass]="getMatchStatusClass(sug.matchStatus)">
                                    {{ sug.explanation.startsWith('✅ Déjà réconcilié') ? 'MATCHED' : sug.matchStatus }}
                                </span>
                                <span *ngIf="sug.explanation.toLowerCase().includes('avoir') || (sug.f8Amount < 0)" class="avoir-tag">AVOIR</span>
                            </div>
                            <span class="text-xs text-gray-400">{{ sug.f8Timestamp }}</span>
                        </div>

                        <p class="text-sm text-gray-600 mb-3">{{ sug.explanation }}</p>

                        <div *ngIf="sug.suggestedOrderIds?.length > 0" class="flex flex-wrap gap-1 mb-3">
                            <button *ngFor="let id of sug.suggestedOrderIds" (click)="goToOrderDetails(id)"
                                class="px-2 py-0.5 bg-blue-50 text-blue-700 hover:bg-blue-100 border border-blue-100 rounded text-xs font-bold transition">
                                #{{ id }}
                            </button>
                        </div>

                        <div class="flex items-center justify-between pt-2 border-t border-gray-100">
                            <div class="text-xs text-gray-400">
                                Score: <span class="font-bold" [class.text-green-500]="sug.confidenceScore >= 80"
                                    [class.text-amber-500]="sug.confidenceScore < 80">{{ sug.confidenceScore }}%</span>
                                <span *ngIf="sug.discrepancy !== 0 && sug.discrepancy !== null"> |
                                    Écart: <span class="font-bold text-red-500">{{ sug.discrepancy | number:'1.2-2' }}
                                        MAD</span>
                                </span>
                            </div>
                            <button *ngIf="sug.matchStatus !== 'ORPHAN_F8' && sug.suggestedOrderIds?.length > 0"
                                (click)="confirmMatch(sug)"
                                [disabled]="confirmingIds.has(sug.suggestedCashJournalIds?.[0] || sug.cashJournalId) || confirmedIds.has(sug.suggestedCashJournalIds?.[0] || sug.cashJournalId) || sug.explanation.startsWith('✅ Déjà réconcilié')"
                                class="btn-confirm"
                                [ngClass]="{'confirmed': confirmedIds.has(sug.suggestedCashJournalIds?.[0] || sug.cashJournalId) || sug.explanation.startsWith('✅ Déjà réconcilié')}">
                                <span
                                    *ngIf="!confirmingIds.has(sug.suggestedCashJournalIds?.[0] || sug.cashJournalId) && !confirmedIds.has(sug.suggestedCashJournalIds?.[0] || sug.cashJournalId) && !sug.explanation.startsWith('✅ Déjà réconcilié')">
                                    Confirmer
                                </span>
                                <span *ngIf="confirmingIds.has(sug.suggestedCashJournalIds?.[0] || sug.cashJournalId)">
                                    <i class="fa fa-spinner fa-spin mr-1"></i> Confirming...
                                </span>
                                <span
                                    *ngIf="confirmedIds.has(sug.suggestedCashJournalIds?.[0] || sug.cashJournalId) || sug.explanation.startsWith('✅ Déjà réconcilié')">
                                    <i class="fa fa-check-circle mr-1"></i> Confirmé
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Orphan Orders Section -->
            <div class="orders-section">
                <div class="controls-bar">
                    <div class="flex items-center gap-2">
                        <i class="fa fa-exclamation-triangle text-red-500"></i>
                        <span class="font-semibold text-gray-700">Commandes Orphelines</span>
                    </div>
                </div>
                <div class="cards-list">
                    <!-- Empty State -->
                    <div *ngIf="report.orphanOrders.length === 0" class="text-center py-10 text-gray-400">
                        <i class="fa fa-smile text-green-500 text-4xl mb-2 block"></i>
                        <p class="font-medium text-gray-600">Aucune commande oubliée !</p>
                        <p class="text-sm">Toutes les commandes virtuelles ont un F8.</p>
                    </div>

                    <!-- Orphans List -->
                    <div *ngFor="let order of report.orphanOrders" class="orphan-card" [class.border-l-4]="true"
                        [class.border-red-500]="!order.matchStatus || order.matchStatus === 'ORPHAN_ORDER'"
                        [class.border-amber-500]="order.matchStatus === 'AMBIGUOUS'"
                        [class.bg-red-50]="!order.matchStatus || order.matchStatus === 'ORPHAN_ORDER'"
                        [class.bg-amber-50]="order.matchStatus === 'AMBIGUOUS'">

                        <div class="flex items-center justify-between mb-2">
                             <div class="flex items-center gap-2">
                                 <span class="font-bold"
                                     [class.text-red-500]="!order.matchStatus || order.matchStatus === 'ORPHAN_ORDER'"
                                     [class.text-amber-600]="order.matchStatus === 'AMBIGUOUS'">
                                     Commande #{{ order.suggestedOrderIds[0] }}
                                 </span>
                                 <span *ngIf="order.ordersTotal === 0 || (order.explanation && order.explanation.toLowerCase().includes('avoir'))" class="avoir-tag">AVOIR</span>
                             </div>
                             <span class="font-bold"
                                 [class.text-red-500]="!order.matchStatus || order.matchStatus === 'ORPHAN_ORDER'"
                                 [class.text-amber-600]="order.matchStatus === 'AMBIGUOUS'">
                                 {{ order.ordersTotal | number:'1.2-2' }} MAD
                             </span>
                        </div>
                        <p class="text-xs mb-2"
                            [class.text-red-500]="!order.matchStatus || order.matchStatus === 'ORPHAN_ORDER'"
                            [class.text-amber-700]="order.matchStatus === 'AMBIGUOUS'">
                            {{ order.explanation || 'Commande "Virtuelle" sans F8 correspondant.' }}
                        </p>
                        <button (click)="goToOrderDetails(order.suggestedOrderIds[0])"
                            class="text-xs font-bold underline"
                            [class.text-red-500]="!order.matchStatus || order.matchStatus === 'ORPHAN_ORDER'"
                            [class.text-amber-600]="order.matchStatus === 'AMBIGUOUS'">
                            Voir les détails
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>